import { PlusOutlined } from '@ant-design/icons'

import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'

import { MEMBER_MANAGE_ACTION_UUID } from '../../../../../constants/uuid'
import { useMemberBankListStore } from '../../../Store/hooks/useStore'

export const MemberBankCreateButton = () => {
  const { setFormMode, toggleAccountFormVisible } = useMemberBankListStore(
    state => pick(state, ['setFormMode', 'toggleAccountFormVisible'])
  )

  const handleCreate = () => {
    setFormMode(FormMode.CREATE)
    toggleAccountFormVisible()
  }

  return (
    <ActionButton
      icon={<PlusOutlined />}
      type='primary'
      uuid={MEMBER_MANAGE_ACTION_UUID}
      onClick={handleCreate}
    >
      新增银行账号
    </ActionButton>
  )
}
